import React, { useEffect, useState } from "react";
import axios from "axios";
import FileDownload from "js-file-download";
import { addCompany, companyList, DeleteCompany, EditCompany } from "./modal";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllCompanyList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Users/ComapanyProfile/Details`
    );
    return res.data.data;
  } catch (error) {
    return error;
  }
};

export const getCompanyProfileByUserId = async (userId: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Users/ComapanyProfile/${userId}/Details`
    );
    return res.data.data;
  } catch (error) {
    return error;
  }
};

export const AddCompanyProfile = async (payload: addCompany) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Users/ComapanyProfile/Add`,
      payload
    );
    return res.data;
  } catch (error) {
    return error;
  }
};

export const editCompanyProfile = async (payload: EditCompany) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Users/ComapanyProfile/Update`,
      payload
    );
    return res.data;
  } catch (error) {
    return error;
  }
};
export const DeleteCompanyProfile = async (payload: DeleteCompany) => {
  try {
    const res = await axios.delete(
      `${API_BASE_URL}/api/Users/ComapanyProfile/Delete`,
      {
        data: payload,
      }
    );
    return res.data;
  } catch (error) {
    return error;
  }
};
export const DeleteCompanyProfile_2 = async (companyProfileID: number) => {
  try {
    const res = await axios.delete(
      `${API_BASE_URL}/api/Users/ComapanyProfile/${companyProfileID}`,
    );
    return res.data;
  } catch (error) {
    return error;
  }
};
export const uploadLogo = async (
  file: File,
  companyProfileID: number,
) => {
  try {

    if (!file) {
      throw new Error("File is undefined");
    }

    const formData = new FormData();
    formData.append("file", file);

    const res = await axios.post(
      `${API_BASE_URL}/api/Users/ComapanyProfile/Upload/File?CompanyProfileID=${companyProfileID}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};


export const getLogo = async (companyProfileID: any) => {
  try {
    const response = await axios({
      url: `${API_BASE_URL}/api/Users/ComapanyProfile/${companyProfileID}/download-file`,
      method: "GET",
      responseType: "blob", // Important to receive blob data
    });

    // Convert the blob to a base64 string using a FileReader
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(response.data);
      reader.onloadend = () => {
        const base64data = reader.result; // Base64 string
        resolve(base64data);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });

  } catch (error) {
    console.error("@@Error:", error);
    return error;
  }
};